import { createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../lib';
import { getPlatform, SitePlatform, shouldReduceUISize } from '../config';

interface ConfigState {
  platform: SitePlatform;
  reduceUISize: boolean;
}

const initialState: ConfigState = {
  platform: getPlatform(),
  reduceUISize: shouldReduceUISize(),
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
});

export const configSelectors = {
  isWix: createSelector(
    (state: RootState) => state.config,
    (config): boolean => config.platform === 'wix'
  ),
  isStandalone: createSelector(
    (state: RootState) => state.config,
    (config): boolean => config.platform === 'standalone'
  ),
};
